// extracted by mini-css-extract-plugin
module.exports = {"section":"MySentApplication_section__1D4rW","min-h":"MySentApplication_min-h__3gQT-","loading":"MySentApplication_loading__14xx5"};